<template lang="pug">
  v-col
    v-row(no-gutters justify="space-between")
      div
        v-btn(icon, v-show="step === 'codeNumber'", @click.prevent="setStep")
          v-icon arrow_back
      div
        v-btn(icon, color="red", @click.prevent="setHomePage")
          v-icon close
    v-row(
      justify="center",
      align="center")
      img(src="@/assets/logo/logo.svg" width=48 height=48 class="mr-1")
      span(class="headline font-weight-bold text-uppercase pl-1 d-inline-block") Kluchi.kg
</template>

<script lang="js">
export default {
  name: 'Logo',
  props: {
    step: {
      type: String,
      default: ''
    }
  },
  methods: {
    setStep() {
      this.$emit('set-step-value', 'phoneNumber')
    },
    setHomePage() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
